import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from "react-toastify";
import axios from 'axios';
import axiosInstance from '../../axiosInstance';
import { API_URL_All } from '../../api';
import * as general from '../../libs/general';

const OrderCommentModal = ({
  orderId,
  orderDetailId,
  /** Trang tra cứu public: mã vận đơn để tải comment không cần đăng nhập. */
  refer,
  isPublic = false,
  readOnly = false,
  show,
  handleClose,
}) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isPublic ? refer : (orderId || orderDetailId)) {
      fetchComments(orderId, orderDetailId);
    }
  }, [orderId, orderDetailId, refer, isPublic]);

  const fetchComments = async (id, detailId) => {
    try {
      setLoading(true);
      if (isPublic) {
        const response = await axios.get(`${API_URL_All}/api/clients/findOrderComments`, {
          params: { refer },
        });
        if (response.data.success) {
          setComments(response.data.data || []);
        }
      } else if (id) {
        const response = await axiosInstance.get(`/api/order-comments/${id}`);
        if (response.data.success) {
          setComments(response.data.data || []);
        }
      } else if (detailId) {
        const response = await axiosInstance.get(`/api/order-comments/detail/${detailId}`);
        if (response.data.success) {
          setComments(response.data.data || []);
        }
      }
    } catch (error) {
      console.error('Error fetching comments:', error);
      toast.error('Không thể tải danh sách comment');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newComment.trim()) {
      toast.warning('Vui lòng nhập nội dung comment');
      return;
    }

    try {
      setLoading(true);
      if (orderId) {
        const response = await axiosInstance.post('/api/order-comments', {
          orderId: orderId,
          content: newComment.trim()
        });

        if (response.data.success) {
          toast.success('Thêm comment thành công');
          setNewComment('');
          fetchComments(orderId, orderDetailId); // Reload comments
        } else {
          toast.error(response.data.message || 'Không thể thêm comment');
        }
      }else if (orderDetailId) {
        const response = await axiosInstance.post('/api/order-comments/detail', {
          orderDetailId: orderDetailId,
          content: newComment.trim()
        });

        if (response.data.success) {
          toast.success('Thêm comment thành công');
          setNewComment('');
          fetchComments(orderId, orderDetailId); // Reload comments
        } else {
          toast.error(response.data.message || 'Không thể thêm comment');
        }
      }

    } catch (error) {
      console.error('Error adding comment:', error);
      toast.error('Có lỗi xảy ra khi thêm comment');
    } finally {
      setLoading(false);
    }
  };

  const content = (
    <div className='col-md-12 mb-3 px-4'>
      {!isPublic && !readOnly && <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label className='form-label'>Nội dung comment</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Nhập nội dung comment..."
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            disabled={loading}
          />
        </Form.Group>
        <div className="text-center">
          <Button
            variant="primary"
            type="submit"
            size='sm'
            disabled={loading || !newComment.trim()}
          >
            {loading ? 'Đang xử lý...' : 'Thêm'}
          </Button>
        </div>
      </Form>}

      <hr className="my-4" />

      <div className="comments-history">
        <label className="form-label">Lịch sử comment</label>
        {loading && comments.length === 0 ? (
          <div className="text-center py-3">
            <span>Đang tải...</span>
          </div>
        ) : comments.length === 0 ? (
          <div className="text-center text-muted py-3">
            Chưa có comment nào
          </div>
        ) : (
          <div className="comments-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            {comments.map((comment, index) => (
              <div
                key={comment.id || index}
                className="comment-item border rounded p-3 mb-2"
                style={{ backgroundColor: '#f8f9fa' }}
              >
                <div className="d-flex justify-content-between align-items-start mb-2">
                  {/* <strong className="text-primary">
                      {comment.createdBy || 'Unknown'}
                    </strong> */}
                  <small className="text-muted">
                    {general.formatDateTime2(comment.createdDate)}
                  </small>
                </div>
                <div className="comment-content" style={{ whiteSpace: 'pre-wrap' }}>
                  {comment.content}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  if (show !== undefined) {
    return (
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Comment đơn hàng</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
              aria-label="Đóng"
            ></button>
          </div>
          <div className="modal-body">
            {content}
          </div>
          <div className="modal-footer">
            <Button variant="secondary" size="sm" onClick={handleClose}>
              Đóng
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  return content;
};

export default OrderCommentModal;
